import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return d?.msg || String(d);
};
